import type { Environment } from './environment.interface';

export const environment: Environment = {
  apiUrl: 'https://api-test.biuro.empiria.edu.pl',
};
